import {DateTime} from 'luxon';
import {parseEventDateTime} from '~/common/utils/time';
import {selectIsPremium as selectIsEviteEventPremium} from './eviteEvent';

export const selectEventDetails = ({eventDetails}) => eventDetails;
export const selectGuestsOfHonor = (state) => selectEventDetails(state)?.guestsOfHonor ?? [];
export const selectHostName = (state) => selectEventDetails(state)?.host_name ?? '';
export const selectIsPremium = (state) =>
  selectEventDetails(state)?.isPremium || selectIsEviteEventPremium(state).isPremium;
export const selectRegistriesData = (state) => selectEventDetails(state).registriesData ?? false;
export const selectMaxAdditionalGuests = (state) => selectEventDetails(state).maxGuests;
export const selectAllowKids = (state) => !!selectEventDetails(state).allowKids;
export const selectAllowGuestsToBringMoreGuests = (state) =>
  selectEventDetails(state)?.allowGuests ?? false;
export const selectAllowGuestsToInviteMore = (state) =>
  selectEventDetails(state)?.allowInviteMore ?? false;

export const selectEventId = (state) => selectEventDetails(state)?.eventId;
export const selectEventStart = (state) => selectEventDetails(state)?.start;
export const selectEventTimezone = (state) => selectEventDetails(state)?.known_timezone_name;
export const selectEventIsFuneral = (state) =>
  selectEventDetails(state)?.eventType === 'funeral_memorial_service';
export const selectEventIsFutureNonFuneral = (state) => {
  const eventStart = selectEventStart(state);
  const timezone = selectEventTimezone(state);
  const eventIsFuneral = selectEventIsFuneral(state);
  const eventStartDt = parseEventDateTime(eventStart, timezone);
  const midnightTonight = DateTime.now().plus({days: 1}).startOf('day');
  const eventIsAfterToday = eventStartDt.isValid && eventStartDt > midnightTonight;
  return !eventIsFuneral && eventIsAfterToday;
};
